import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCommunity = lazy(() => import("@/pages/admin/AdminCommunity"));

export const Route = createFileRoute("/admin/community")({
  component: AdminCommunity,
});
